<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>停车管理</el-breadcrumb-item>
            <el-breadcrumb-item>车库管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center;justify-content:space-between;width:100%">
              <div style="display:flex;align-items:center;margin-right:20px">
                <el-input v-model="serchName" placeholder="请输入车库名称" @input="watchInput"  clearable>
                  <el-button slot="append" icon="el-icon-search" @click="doFilter" ></el-button>
                </el-input>
              </div>
              <div style="display:flex;align-items:center;width:20%;justify-content:space-between;">
                <el-button
                  v-if="isMenuExit('pro:garage:add')"
                  type="primary"
                  size="mini"
                  style="display:flex;align-items:center"
                  @click="add()"
                >添加车库</el-button>
                <!-- <el-button
                  type="primary"
                  size="mini"
                  style="display:flex;align-items:center"
                  @click="exportInfo()"
                >导出</el-button> -->
                 <el-tooltip class="item" effect="dark" content="导出" placement="top-end" v-if="isMenuExit('pro:garage:export')">
                    <img  @click="exportInfo" class="icon_hover" src="../../assets/image/export.png" alt="" srcset="">
                </el-tooltip>
                <el-upload
                  v-if="isMenuExit('pro:garage:import')"
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="uploadHead"
                  :show-file-list="false"
                  :on-success="handleAppSuccess"
                  :data="uploadData"
                >
                  <!-- <el-button type="success" size="mini" icon="el-icon-upload">导入</el-button> -->
                <el-tooltip class="item" effect="dark" content="导入" placement="top-end">
                    <img  class="icon_hover" src="../../assets/image/import.png" alt="" srcset="">
                </el-tooltip>
                </el-upload>
              </div>
            </div>
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table
              stripe
              :data="tableData"
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="编号">
                <template slot-scope="scope">
                  <span>{{ scope.row.index }}</span>
                </template>
              </el-table-column>
              <el-table-column label="车库名称">
                <template slot-scope="scope">
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="车位数量">
            <template slot-scope="scope">
              <span>{{ scope.row.carportCount }}</span>
            </template>
              </el-table-column>-->
              <el-table-column label="自有车位">
                <template slot-scope="scope">
                  <span>{{scope.row.carportCount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="已售车位">
                <template slot-scope="scope">
                  <span>{{scope.row.elementCount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="当前车位车辆数">
                <template slot-scope="scope">
                  <span>{{scope.row.carCount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="车库平面图">
                <template slot-scope="scope">
                  <!-- <span>{{scope.row.carportPhoto}}</span> -->
                  <el-image v-if="scope.row.photo!=''" style="width: 5vh; height: 5vh;cursor: pointer;" :src="scope.row.photo" :preview-src-list="scope.row.srcList"></el-image>
                  <img v-else src="../../assets/image/zanwutupian.png" style="width: 5vh; height: 5vh;cursor: pointer;" />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <span class="color1 hand" v-if="isMenuExit('pro:garage:edit')" @click="edit( scope.row)">修改</span>
                </template>
              </el-table-column>
              <el-table-column label="查看" width="100">
                <template slot-scope="scope">
                  <span class="color1 hand" v-if="isMenuExit('pro:garage:info')" @click="look( scope.row)">查看</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100, 500, 1000]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
          <!-- 添加弹出框 -->
          <el-dialog
            :title="diaTitle"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
          >
            <el-form
              :model="editForm"
              ref="editForm"
              label-width="150px"
              label-position="left"
              class="teamPage"
              :rules="teamRules"
            >
              <el-form-item label="车库名称" prop="name">
                <el-input v-model="editForm.name" autocomplete="off" style="width:220px"></el-input>
              </el-form-item>
               <el-form-item label="车位图">
                <el-upload
                  class="avatar-uploader"
                  v-bind:action="uploadUrl1"
                  :headers="uploadHead1"
                  :data="{type:223}"
                  :show-file-list="false"
                  :on-success="handleIconSuccess"
                >
                  <img v-if="icon" :src="icon" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="editFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow('editForm')">确 定</el-button>
            </div>
          </el-dialog>
            <!-- 导出成功弹出框 -->
          <el-dialog
            :title="dialogTitle1"
            :visible.sync="imoportVisible"
            center
            :append-to-body="true"
            :before-close="handleClose1"
            :lock-scroll="false"
            width="30%"
          >
            <template>
              <el-table :data="tableData1" style="width: 100%" border>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status==0">
                      <i class="el-icon-circle-check" style="color:#07C160"></i>
                    </span>
                    <span v-if="scope.row.status==1">
                      <i class="el-icon-warning-outline" style="color:#f00"></i>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="reason" label="原因">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status==0" style="color:#07C160">{{scope.row.reason}}</span>
                    <span v-if="scope.row.status==1" style="color:#f00">{{scope.row.reason}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-dialog>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      tableData: [], //获取数据
      tableData1: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectId: '',
      serchName: '', //车库名称
      uploadUrl: myHttp.importCarportForExcel, //上传地址
      uploadHead: {
        accessToken: util.session.get('token'),
      },
      uploadData: {
        projectId: '',
        userId: '',
      },
      dataText: '暂无数据',
      uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
      uploadHead1: {
        accessToken: util.session.get('token'),
      },
      editFormVisible: false,
      dialogTitle: '',
      dialogTitle1: '导入',
      editForm: {
        id: '',
        name: '', //车库名
        carportPhoto: '', //车位图片
        // carportPhoto: '', //
      },
      imoportVisible: false,
      icon: '', // 车位停车图
      updateBy: '',
      userId: '',
      diaTitle:'',
      teamRules:{
           name: [
            { required: true, message: '请输入车库名称', trigger: 'change' }
          ],
      }
    }
  },
  mounted() {
    this.projectId = util.session.get('groupId')
    this.userId = util.session.get('user').id
    this.updateBy = util.session.get('user').id
    if (this.projectId == '') {
      this.$store.commit('setGroupId')
      this.projectId = this.$store.state.groupId
    }
    ;(this.uploadData.projectId = this.projectId),
      (this.uploadData.userId = this.userId)
    this.getData()
    // console.log(this.$store.state.token)
  },
  methods: {
    //获取数据
    getData() {
      var that = this
      myHttp
        .secCarportByLikeName({
          projectId: this.projectId,
          name: this.serchName,
          pageSize: this.pageSize,
          pageNum: this.currentPage,
        })
        .then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.carportInfo.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index = that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
                list[i].photo = list[i].carportPhoto && list[i].carportPhoto!=''?base.httpCtx+list[i].carportPhoto:''
                list[i].srcList = list[i].photo && list[i].photo!=''?[list[i].photo]:[]
              }
              that.tableData = list
              that.totalItems = resp.data.data.carportInfo.total
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function () {}
        )
    },
    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.editForm.updateBy = this.updateBy
          that.editForm.projectId = this.projectId
          if(this.editForm.id==''){
               myHttp.createInfoCar(that.editForm).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('创建车库成功')
                    that.editFormVisible = false
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {}
              )
          }else{
                myHttp.updateInfoCar(that.editForm).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('修改车库成功')
                    that.editFormVisible = false
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {}
              )
          }
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 编辑弹框
    edit(row) {
      this.dialogTitle = '修改车库'
      this.editFormVisible = true
      this.editForm = {
        name: row.name,
        carportCount: row.carportCount,
        carportPhoto: row.carportPhoto,
        id: row.id,
      }
      this.icon =row.carportPhoto && row.carportPhoto != '' ? base.httpCtx + row.carportPhoto: ''
      console.log(this.icon)
    },
    //添加车库
    add() {
      this.diaTitle='添加车库'
      this.editFormVisible=true
      this.editForm={
        id: '',
        name: '', //车库名
        carportPhoto: '', //车位图片
      }
      this.icon=''
    },
    // 导出
    exportInfo() {
      var token = this.$store.state.token
      window.open(
        myHttp.exportCarportForExcel +
          '?projectId=' +
          this.projectId +
          '&accessToken=' +
          token
      )
    },
    doFilter() {
      this.getData()
    },
    //
    handleChange(e) {
      this.editForm.useType = e.value
      // console.log(e.value)
    },

    //上传成功监听方法
    handleAppSuccess(res, file) {
      if (res.code == '200') {
        this.imoportVisible = true
        this.tableData1 = res.data.list
        this.getData()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 上传图片
    handleIconSuccess(res, file) {
      this.icon = URL.createObjectURL(file.raw)
      this.editForm.carportPhoto = res.data.savePhotoUrls
    },
    // 查询
    search() {
      this.getData()
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.editFormVisible = false
    },
    handleClose1(done) {
      this.imoportVisible = false
    },
    // 查看车库信息
    look(row) {
      var id = row.id
      this.$router.push({ name: 'carLower', params: { id: id } })
    },
    watchInput(e){
        this.serchName = e
        this.getData()
    },

    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
  },
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
  overflow: auto;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px 10px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 98%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.cur {
  background: #ecf5ff !important;
  /* border: 1px solid   #409EFF !important ; */
  color: #409eff !important  ;
}
.color1{
  color: #409eff;
  cursor: pointer;
}
.avatar{
  width: 100%;
}
label .el-form-item__label{
  text-align: center;
}
 .content >>>.el-input-group--append .el-input__inner{
      width: 200px;
    }
</style>